import React, { useRef, useEffect } from 'react';
import { forEach } from 'lodash';
import { v4 as uuid } from 'uuid';
import { globalEventBus } from '@fiverr-private/futile';
import { REGISTER_IMPRESSION_ITEM_EVENT } from '../useImpressionManager/consts';
import { getContainersData, getElementContainerId, isElementOverflowsParent } from '../../utils';
import {
    CONTAINER_ID_ATTR,
    IMPRESSION_ITEM_ATTR,
    IMPRESSION_PARENT_ATTR,
    ITEM_WITHOUT_CONTAINER_SELECTOR,
    OVERFLOWED_ITEM_ATTR
} from './consts';

const useImpressionContainer = ({
    selfRef = null,
    selfId = null
} = {}) => {
    const containerRef = useRef(null);
    const ref = selfRef || containerRef;
    const impressionIdRef = useRef(getElementContainerId(ref.current) || selfId || uuid());
    const containerId = impressionIdRef.current;

    const registerItem = (itemRef) => {
        itemRef.setAttribute(IMPRESSION_PARENT_ATTR, containerId);
        const itemId = itemRef.getAttribute(IMPRESSION_ITEM_ATTR);
        const selfIdAsContainer = itemRef.getAttribute(CONTAINER_ID_ATTR);

        if (isElementOverflowsParent(itemRef, ref.current)) {
            itemRef.setAttribute(OVERFLOWED_ITEM_ATTR, true);
        }

        globalEventBus.emit(REGISTER_IMPRESSION_ITEM_EVENT, { itemId, containerId, selfIdAsContainer });
    };

    useEffect(() => {
        if (!ref.current) {
            return;
        }

        ref.current.setAttribute(CONTAINER_ID_ATTR, containerId);
        const { containerId: myParentId } = getContainersData(ref.current);

        const itemWithSameParentAsMine = `[${IMPRESSION_ITEM_ATTR}][${IMPRESSION_PARENT_ATTR}="${myParentId}"]`;
        const itemElements = ref.current.querySelectorAll(`${ITEM_WITHOUT_CONTAINER_SELECTOR}, ${itemWithSameParentAsMine}`);
        forEach(itemElements, registerItem);

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ref]);

    return [ref, containerId];
};

export { useImpressionContainer };
